<div class="card-header">
  <slot>
    {{ text | decodeHtmlString }}
  </slot>
</div>
